export type PromptStatus = 'ready' | 'submitting' | 'streaming' | 'error'

export type SendFace = 'idle' | 'ready' | 'sending' | 'stopping' | 'retry'

/** The glyph inside the send button. Faces that share a glyph change colour without a swap. */
export type SendGlyph = 'arrow' | 'mark' | 'stop' | 'retry'

export interface SendFaceInput {
  status: PromptStatus
  hasContent: boolean
  blocked: boolean
  retryable: boolean
}

export function sendFace({ status, hasContent, blocked, retryable }: SendFaceInput): SendFace {
  switch (status) {
    case 'submitting':
      return 'sending'
    case 'streaming':
      return 'stopping'
    case 'error':
      if (blocked) return 'idle'
      if (hasContent) return 'ready'
      return retryable ? 'retry' : 'idle'
    case 'ready':
      return hasContent && !blocked ? 'ready' : 'idle'
  }
}

export const SEND_GLYPH: Readonly<Record<SendFace, SendGlyph>> = {
  idle: 'arrow',
  ready: 'arrow',
  sending: 'mark',
  stopping: 'stop',
  retry: 'retry',
}

export function faceSubmits(face: SendFace): boolean {
  return face === 'ready'
}

/** True when a file matches a native `accept` list of `type/*`, MIME types and `.ext` suffixes; an empty list accepts every file. */
export function fileMatchesAccept(file: Pick<File, 'name' | 'type'>, accept: string): boolean {
  const rules = accept
    .split(',')
    .map((rule) => rule.trim().toLowerCase())
    .filter((rule) => rule !== '')
  if (rules.length === 0) return true
  const type = file.type.toLowerCase()
  const name = file.name.toLowerCase()
  return rules.some((rule) => {
    if (rule.startsWith('.')) return name.endsWith(rule)
    if (rule.endsWith('/*')) return type.startsWith(rule.slice(0, -1))
    return type === rule
  })
}
